// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LandingPageTip_wrapper__2JPfM","pointer":"LandingPageTip_pointer__13W6m","icon":"LandingPageTip_icon__ZkfHI","iconsWrapper":"LandingPageTip_iconsWrapper__kNI7P"};